import { Checkbox, DataSource, ExcludableTextbox, Layout, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutDetentionReport extends Layout {
    checkboxPrintComments: Checkbox;
    detentionReportDatasource: DataSource;
    excludabletextboxCustomerId: ExcludableTextbox;
    excludabletextboxLocationId: ExcludableTextbox;
    switchReportBy: Switch;
    switchReportType: Switch;
    switchSortBy: Switch;
    textboxArrivalDate: Textbox;
    textboxBalanceOf: Textbox;
    textboxDetentionStatus: Textbox;
    textboxRecordType: Textbox;
    textboxStatusOf: Textbox;
    textboxStopType: Textbox;
}
